document.addEventListener("DOMContentLoaded", function() {

  

var allText=document.querySelectorAll(`
h1,
.title strong,
.product-form__submit span,
.full-unstyled-link,
.related-products__heading,
.product__text,
.product__title h1,
.product__tax, 
.badge,
.collection__description p,
.price-item,
.full-unstyled-link,
body:not(.template-rele) .luna-templates__text p
`,
);



    allText.forEach((content,index)=>{

      content.style.height=content.clientHeight+"px";
    })
  
  
  const init=()=>{
    
allText=document.querySelectorAll(`
    h1,
.title strong,
.product-form__submit span,
.full-unstyled-link,
.related-products__heading,
.product__text,
.product__title h1,
.product__tax, 
.badge,
.collection__description p,
.price-item,
.full-unstyled-link,
body:not(.template-rele) .luna-templates__text p
`
);

    /*
    .footer-block__heading,
.footer-block__details-content p,
      */

    
    allText.forEach((content,index)=>{

      if(!content.dataset.content){
        var html=content.innerHTML.trim()
        var text=html
          .replace(/<br\s*\/?>/gi,"\n")
          .replace(/<[^>]+>/g,"")

       content.dataset.content=text
        content.dataset.finalHtml=html.replace(/<br\s*\/?>/gi,"<br>")
        content.dataset.anim_order=index
        content.innerHTML=""
      }
    
    })
  }


var time=0
var nAnim=0
var letter=0
var finishedCount=0


const shuffle=(text,n)=>{
  const chars = "0123456789   ''''°°°°NSEW";
  var result=""

  for(let i=0;i<text.length;i++){
    if(text.charAt(i)==="\n"){
      result+="<br>"
      continue;
    }

    if(i<n){
      result+=text.charAt(i)
    }
    
   if(i==n){
    result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
  }

  return result;
}



const animate=()=>{

  init()
  time++


  allText.forEach((text,index)=>{
    if(text.dataset.animationDone==="true"){
      return;
    }

    letter=Math.floor(time/(1.5))
    var newText=text.dataset.content  
    
    if(letter<newText.length+1){
      text.classList.add("animated")
    } else {
      text.innerHTML=text.dataset.finalHtml || newText.replace(/\n/g,"<br>")
      text.dataset.animationDone="true"
      text.classList.add("animation-done")
      finishedCount++
      return;
    }
              text.innerHTML=shuffle(newText,letter) 
 
  })


}

init()
  
  setTimeout(()=>{
    const interval=setInterval(()=>{
      animate()

      if(finishedCount>=allText.length){
        clearInterval(interval)
      }
    },50)
  },250)


  
})
